module.exports = __webpack_public_path__ + "static/img/12bg_10.111d289.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/12bg_10.png
// module id = 639
// module chunks = 1